import { combineReducers } from 'redux';

import createIncidents from './createIncidents';
import incidentsComparison from './incidentsComparison';

const table = combineReducers({
  createIncidents,
  incidentsComparison,
});

export default table;
